import { DEFAULT_CHECKED_COLOR, DEFAULT_SIZE, DEFAULT_UNCHECKED_COLOR, TOGGLE_SWITCH_MARGIN } from './consts';

export const getSizeWithMargin = (size = DEFAULT_SIZE) => `${size - TOGGLE_SWITCH_MARGIN * 2}px`;

export const getToggleTransform = (size = DEFAULT_SIZE) => `calc((${getSizeWithMargin(size)} * 1.8) - ${size}px)`;

export const getCheckedColor = (checked?: boolean, checkedColor?: string) =>
  checked ? checkedColor ?? DEFAULT_CHECKED_COLOR : DEFAULT_UNCHECKED_COLOR;
